<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-lg-3">
                <div class="card">
                    <div class="card-body">
                        <div class="w-75 m-auto">
                            <img class="img-fluid rounded-circle" src="../../../../../../assets/images/warehouse.png">
                        </div>
                    </div>
                    <div class="card-body mt-0 p-t-0 p-b-0">
                        <hr class="m-t-0">
                        <h5 class="mb-0">{{warehouse.name}}</h5>
                        <span class="" v-html="warehouse.description"/>
                        <hr>
                        <address class="mt-2">
                            <strong><i class="fas fa-map-marked-alt"/></strong><br>
                            {{warehouse.address.line1}}<br>
                            <span v-if="warehouse.address.line2">{{warehouse.address.line2}}<br></span>
                            {{warehouse.address.city}}, {{warehouse.address.state}}<br>
                            {{warehouse.address.postal_code}}, {{warehouse.address.country}}<br>
                        </address>
                    </div>
                    <div class="card-footer p-t-0 p-b-0 mb-3">
                        <hr class="m-t-0">
                        <div v-if="currentOrg.role === 'ORG_ADMIN'">
                            <router-link :to="{ name: 'editmarketplacewarehouse', params: {warehouseid: warehouseid}}"
                                         class="btn btn-info ml-auto">Edit
                            </router-link>

                            <button class="btn btn-secondary float-right">Delete</button>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-lg-9">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-blue">
                            <div class="card-header">
                                <h4 class="card-title">Add stock to Warehouse</h4>
                            </div>
                            <form @submit.prevent="handleSubmitAdd">
                                <div class="card-body">
                                    <div class="form-group row">
                                        <label class="col-sm-3 text-right control-label col-form-label">Good</label>
                                        <div class="col-sm-7 mt-2" v-if="!addGood.good">
                                            <a class="" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                                               href="javascript:void(0)"><b>Click here to
                                                add commodity</b></a>
                                        </div>
                                        <div class="col-sm-7" v-else>
                                            <p class="form-control" data-target="#searchAndSelectCommodityModal" data-toggle="modal">{{addGood.good.name}}
                                                <span>({{addGood.good.code}})</span> -{{addGood.good.variety}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-3 text-right control-label col-form-label">Quantity</label>
                                        <div class="col-sm-7">
                                            <div class="input-group">
                                                <input :class="{'is-invalid': submitted && errors.has('quantity')}"
                                                       class="form-control"
                                                       data-vv-as="Quantity"
                                                       id="quantity"
                                                       name="quantity"
                                                       placeholder="Quantity"
                                                       step="any"
                                                       type="number"
                                                       v-model="addGood.quantity"
                                                       v-validate="'required','min_value:0'">
                                                <input :class="{'is-invalid': submitted && errors.has('quantity')}"
                                                       :value="addGood.unit" class="form-control" disabled
                                                       style="max-width: 40px">
                                            </div>
                                            <div class="invalid-feedback" style="display: block"
                                                 v-if="submitted && errors.has('quantity')">{{
                                                errors.first('quantity')
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-3 text-right control-label col-form-label">Remarks</label>
                                        <div class="col-sm-7">
                                            <div class="input-group">
                                                <input :class="{'is-invalid': submitted && errors.has('ref')}"
                                                       class="form-control"
                                                       data-vv-as="Remarks"
                                                       id="ref"
                                                       name="ref"
                                                       placeholder="Remarks"
                                                       type="text"
                                                       v-model="addGood.ref"
                                                       v-validate="'required'">
                                            </div>
                                            <div class="invalid-feedback" style="display: block"
                                                 v-if="submitted && errors.has('ref')">{{ errors.first('ref') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="form-group m-b-0 text-right">
                                        <div class="button-group">
                                            <button class="btn waves-effect waves-light btn-success" type="submit">
                                                Save
                                            </button>
                                            <button class="btn waves-effect waves-light btn-secondary" type="reset">
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <search-select-commodity :checked-commodity-ids="commodityIds" :single-select="true"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import SearchSelectCommodity from "../../../../common/SearchSelectCommodity";

    export default {
        name: "AddCommodityToWarehouse",
        components: {SearchSelectCommodity},
        props: ["marketplaceid", "warehouseid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                warehouse: {
                    name: null,
                    description: null,
                    address: {
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null
                    },
                    inventory: [],
                },
                addGood: {
                    good: null,
                    quantity: null,
                    unit: null,
                    ref: null,
                },
                commodityIds: []
            }
        },
        mounted() {
            this.getWareHouse();
        },
        methods: {
            async getWareHouse() {
                let reply = await this.$http.get(`/marketplaces/${this.marketplaceid}/warehouses/${this.warehouseid}`);
                this.warehouse = reply.data;
            },
            handleSubmitAdd() {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        console.log(valid)
                        if (valid) {
                            this.addGoodToWarehouse();
                        }
                    });
            },
            async addGoodToWarehouse() {
                try {
                    let payload = {
                        commodity_id: this.addGood.good.id,
                        quantity: this.addGood.quantity,
                        unit_id: this.addGood.good.unit_id,
                        ref: this.addGood.ref
                    }
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/add`, payload);
                    await this.$router.push({name: 'viewmarketplacewarehouse'});
                    this.$toastr('success', 'Good add to warehouse', 'Success');
                } catch (e) {
                    this.$toastr('error', 'Could not add stock to warehouse', 'Failed');
                } finally {
                    $('#addGoodModal').modal('hide')
                }
            },
            setCommodity(e) {
                let commodity = e.length > 0 ? e[0] : null;
                if (commodity) {
                    if (!commodity.rate.amount) {
                        this.$toastr('warning', 'Commodity rate is not set, edit commodity and set rate', 'Warning');
                        this.$router.push({
                            name: "viewcommodity",
                            params: {commodityid: commodity.id}
                        });
                    } else {
                        this.addGood.unit = commodity.unit ? commodity.unit.symbol : null;
                    }
                    this.addGood.good = commodity;
                    this.commodityIds = [commodity.id];
                }

            }
        }
    }
</script>

<style scoped>

</style>
